import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * AI Module Service Stores
 * Updated to match backend api-types
 */
export const aiStores: ServiceStoreConfig[] = [
  {
    name: "ingestion",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "nlp-service",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "openai",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "openai-rag",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "processing",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "querying",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "search-query-builder",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "ticket-classifier",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "universal-indexer",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "vector-storage",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
];
